import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <blockquote>
      <p parentName="blockquote">{`I am Navneet. Urbanite. Foodie. Explorer. Coder.`}</p>
    </blockquote>
    <p>{`Munich via Bangalore, Delhi and Jaipur. I am a Master student at the Technical University of Munich. `}<br />{`
A tech enthusiast with interest in programming and building stuff.
I keep exploring all the new technologies and integrating them to build innovative solutions.
I am drawn towards new technologies and a minimalist approach. I have a passion for art, travel as much as I can, and obsess over dogs.
Also, if it is not apparent enough, I like Machine Learning.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      